
import Vue from 'vue';
import VueRouter from 'vue-router';

// ページコンポーネント
import ProductContentCompo from '../../../vue/product/product-content.vue';

export default function () {

    if ($('body#page-product').length && $('#app-product').length) {
        load_json();
    }

    /**
     * json読み込み
     */
    function load_json() {
        $.ajax('inc_product_data.php', { dataType: 'json', cache: false })
        .done(show_vue);
    }

    /**
     * ムービー一覧作成
     */
    function show_vue(json) {

        // ルーター設定
        Vue.use(VueRouter);
        const router = new VueRouter({
            routes: [
                {
                    path: '/',
                    component: ProductContentCompo
                },
                {
                    name: 'category',
                    path: '/:category',
                    component: ProductContentCompo,
                }
            ]
        });

        // Vue インスタンス
        const vm = new Vue({
            el: '#app-product',
            router,
            data: {
                product_list: json
            }
        });
    }
}


// WEBPACK FOOTER //
// ./js/page/product/product.js